/**
 * Format a numeric value with thousand-separator commas.
 * Leaves non-numeric values unchanged.
 */
export const formatNumber = (value) => {
  if (value == null || value === '') return '-';
  const num = typeof value === 'number' ? value : parseFloat(value);
  if (isNaN(num)) return String(value);
  return num.toLocaleString('en-US');
};

/**
 * Returns the CSS modifier class for a change value.
 * Positive → gain color, negative → loss color.
 */
export const getChangeClass = (value) => {
  if (value == null) return '';
  const num = typeof value === 'number' ? value : parseFloat(value);
  if (isNaN(num)) return '';
  if (num > 0) return 'gain';
  if (num < 0) return 'loss';
  return '';
};

/**
 * Format a change value with an explicit sign prefix.
 */
export const formatChangeValue = (value) => {
  if (value == null || value === '') return '-';
  const num = typeof value === 'number' ? value : parseFloat(value);
  if (isNaN(num)) return String(value);
  const formatted = Math.abs(num).toLocaleString('en-US');
  if (num > 0) return `+${formatted}`;
  if (num < 0) return `-${formatted}`;
  return formatted;
};
